import { useMutation } from "@tanstack/react-query";
import { deletePage } from "../api/deletePage";
import {
  getPagesListByBrandQueryData,
  invalidatePagesListByBrandsQuery,
  setPagesListByBrandQueryData,
} from "../queries/usePagesListByBrandQuery";
import { Page } from "../types";

export const useDeletePageMutation = (brandId: string) => {
  return useMutation({
    mutationFn: async ({
      pageId,
      pages,
    }: {
      pageId?: string;
      pages: Page[];
    }) => {
      const updatedPages = pages.filter(({ id }) => id !== pageId);
      const previousData = getPagesListByBrandQueryData(brandId);

      setPagesListByBrandQueryData(brandId, updatedPages);

      await deletePage(brandId, pageId);

      return previousData;
    },
    onSettled: () => {
      if (!brandId) {
        return;
      }
      invalidatePagesListByBrandsQuery(brandId);
    },
    onError: (e) => {
      console.error("Error occurred when deleting page", e);
    },
  });
};
